import { Box, Button, Card, CardActions, CardContent, CardMedia, Grid, IconButton, Menu, MenuItem, Modal, Typography } from '@mui/material';
import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';

const TemplateCard = ({ template, onEdit, onView, onStatusToggle, hideStatus,onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [hover, setHover] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const openMenu = Boolean(anchorEl);
  console.log("template:", template);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenPopup = () => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  return (
    <Grid item xs={12} sx={{ padding: 2, width: 'auto' }}>
      <Card
        sx={{
          maxWidth: 600,
          boxShadow: 'none',
          border: '1px solid #cacaca',
          borderRadius: 3,
          position: 'relative',
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {/* Card Actions */}
        <CardActions sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={handleClick}
            sx={{
              color: '#000000',
              backgroundColor: 'transparent',
              '&:hover': { backgroundColor: 'transparent' },
            }}
          >
            <MoreVertIcon />
          </Button>
          <Menu anchorEl={anchorEl} open={openMenu} onClose={handleClose}>
            <MenuItem onClick={() => { onView(template); handleClose(); }}>View</MenuItem>
            <MenuItem onClick={() => { onEdit(template); handleClose(); }}>Edit</MenuItem>
            {!hideStatus && (

              <MenuItem onClick={() => { onStatusToggle(template); handleClose(); }}>
                {template.status ? 'Deactivate' : 'Activate'}
              </MenuItem>
            )}
             {!hideStatus && (
              <MenuItem onClick={() => { onDelete(template); handleClose(); }}>Delete</MenuItem>
              )}

          </Menu>
        </CardActions>

        {/* Card Media */}
        <Box sx={{ position: 'relative' }}>
          <CardMedia
            sx={{
              height: 250,
              mb: 2,
              borderRadius: 2,
              border: '1px solid #cacaca',
            }}
            image={template?.output}
            title={template.name}
          />
          {hover && (
            <IconButton
              onClick={handleOpenPopup}
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                color: '#fff',
                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
              }}
            >
              <VisibilityIcon />
            </IconButton>
          )}
        </Box>

        {/* Card Content */}
        <CardContent sx={{ mb: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontSize: '14px', fontWeight: 'bold', textAlign: 'center' }}
            >
              Template: {template?.name}
            </Typography>
            {!hideStatus && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ marginTop: '0.5rem', fontSize: '0.875rem' }}
              >
                Status: {template.status ? 'Active' : 'Inactive'}
              </Typography>
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Popup modal */}
      <Modal open={openPopup} onClose={handleClosePopup}>
        <Box
          sx={{
            position: 'fixed',
            padding: 2,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '35%',
            height: '50%',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            outline: 'none',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Button
            onClick={handleClosePopup}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              zIndex: 1,
              color: 'rgba(0, 0, 0, 0.6)',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'transparent',
                color: 'rgba(0, 0, 0, 1)',
              },
            }}
          >
            <CloseIcon />
          </Button>
          <img
            src={template?.output}
            alt={template.name}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </Box>
      </Modal>
    </Grid>
  );
};

export default TemplateCard;
